module.exports = __webpack_public_path__ + "img/up.8adf7710.png";